// Module
var code = `<section class="unsupported-browser-help-wrapper" role="alert" aria-live><span translate="go-recorder_unsupported-browsers-warning"></span> <a class="tertiary-btn light" href="{{\$ctrl.data.linkUrl}}" target="_blank" aria-label="unsupported browser help" translate="go-recorder-error_supported-browsers-troubleshooting"></a></section>`;
// Exports
export default code;